import React from "react";

export default function VersionFooter() {
  const version = process.env.REACT_APP_VERSION || "unknown";
  return <p>Version {version}</p>;
}